import { NgModule } from '@angular/core';
import { Resizable } from './resizable.directive';
import { ResizeHandle } from './resizeHandle.directive';
export var ResizableModule = (function () {
    function ResizableModule() {
    }
    ResizableModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [Resizable, ResizeHandle],
                    exports: [Resizable, ResizeHandle]
                },] },
    ];
    /** @nocollapse */
    ResizableModule.ctorParameters = function () { return []; };
    return ResizableModule;
}());
//# sourceMappingURL=resizable.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-resizable-element/dist/esm/src/resizable.module.js
// module id = 1269
// module chunks = 4